import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const useCourseModuleCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/course-module', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-module-list'] });
    }
  });
};

export const useCourseModuleUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: any }) => {
      const res = await request.patch(`/course-module/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-module-list'] });
    }
  });
};

export const useCourseModuleReorder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { courseId: string; modules: Array<{ id: string; orderIndex: number }> }) => {
      const res = await request.put('/course-module/reorder', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-module-list'] });
    }
  });
};

export const useCourseModuleDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/course-module/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['course-module-list'] });
    }
  });
};
